import { render } from "./DashboardIcon.vue?vue&type=template&id=6fc6b148"
import script from "./DashboardIcon.vue?vue&type=script&lang=js"
export * from "./DashboardIcon.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__